exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-button-color{background-color:#607d8d!important}.error{color:red}.success{color:green}.warning{color:#ff4500}.pagetitleText{color:#0e0052;text-transform:uppercase;font-size:1.3rem!important}@media (min-width:320px) and (max-width:767px){.mobile-width{min-width:100%;display:inline-block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7983f621","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/maintenance/vehicleServiceHistory/vehicleServiceHistory.vue
// module id = 1714
// module chunks = 0